module.exports = __webpack_public_path__ + "img/17.5256eb39.png";